import React from "react"
import {Menu, Tooltip} from "antd";
import {Link} from "react-router-dom";

const CollapseTree = ({cd, items, SubComponents, treeIndex, key, ...props}) => {
    //console.log('ct', items, props.subMenuKey, key)

    const groups = [...new Set(items.map(v => v.tree[treeIndex] || ''))];
    return groups.sort().map((m, i) => {
        const group = items.filter(v => (v.tree[treeIndex] == m))


        if (group.length) {
            if (group.length == 1) {
                const document = group[0]
                return SubComponents.LeafComponent({
                    item: document,
                    cd: cd,
                    key: '_2_' + i + m,
                    ...props
                })
            }
                // <SubComponents.LeafComponent item={document} cd={cd}  key={'_2_' + i + m} {...props}/>}
            else {
                return SubComponents.BranchComponent({
                    groupDef: m,
                    idx: i+ m,
                    key: '_' + i + m,
                    TreeChild: ({key, ...props2}) =>
                        CollapseTree({key: 'ct', cd, items: group, SubComponents, treeIndex: treeIndex + 1,
                                ...props2}),
                    ...props
                        /*
                        <CollapseTree
                            key={"ct"}
                            cd={cd}
                            items={group}
                            SubComponents={SubComponents}
                            treeIndex={treeIndex + 1}
                            {...props2}/>,                    ...props*/
                })
                /* return <SubComponents.BranchComponent
                    groupDef={m}
                    idx={i + m}
                    key={'_' + i + m}
                    TreeChild={({key, ...props2}) =>
                        <CollapseTree
                            key={"ct"}
                            cd={cd}
                            items={group}
                            SubComponents={SubComponents}
                            treeIndex={treeIndex + 1}
                            {...props2}
                            />}
                    {...props}>
                </SubComponents.BranchComponent> */
            }
        } else {
            return 'Пусто'
        }
    })
}

const TreeRender = ({cd, data, MainComponent, LeafComponent, BranchComponent, collapser, splitter, ...props}) => {
    const preparedData = data.map( i => ({...i, tree: [...collapser(i.path.split(splitter)), i.title]}))
    return <MainComponent {...props}>
        {
            CollapseTree(
                {cd,
                    items: preparedData,
                    SubComponents: {LeafComponent, BranchComponent},
                    key: 'rt',
                    treeIndex: 0})
        }
    </MainComponent>
}

export default TreeRender